import AWS from 'aws-sdk'
import { Buffer } from 'buffer'

export const replaceFromObject = (ogObj, f) => {
    function replaceStringInObject(obj) {
        for (let key in obj) {
            if (typeof obj[key] === 'string') {
                obj[key] = f(obj[key])
            } else if (Array.isArray(obj[key])) {
                // If the property is an array, loop through its elements
                for (let i = 0; i < obj[key].length; i++) {
                    // Check if the array element is a string before replacing
                    if (typeof obj[key][i] === 'string') {
                        obj[key][i] = f(obj[key][i])
                    } else if (typeof obj[key][i] === 'object') {
                        // If the array element is an object, recursively call the function
                        replaceStringInObject(obj[key][i])
                    }
                }
            } else if (typeof obj[key] === 'object') {
                // If the property is an object, recursively call the function
                replaceStringInObject(obj[key])
            }
        }
    }

    const obj = JSON.parse(JSON.stringify(ogObj))
    replaceStringInObject(obj)
    return obj
}

export const replaceS3 = (d) =>
    replaceFromObject(d, (str) =>
        str.includes('.s3')
            ? str?.split?.('drivebuddyz')?.join?.('cactus-s3')?.split?.('cactus-s3')?.join?.('cactus-storage-s3')?.split?.('us-east-2.')?.join?.('eu-west-3.')
            : str
    )


const servers = {
  // x: "http://localhost:8080",
  // a: "http://localhost:8080",
  // b: "http://localhost:8080",
  // c: "http://localhost:8080",
  x: "https://2ybemjudda.eu-west-3.awsapprunner.com",
  a: "https://awzip8yzdm.eu-west-3.awsapprunner.com",
  b: "https://k2b6qugmhv.eu-west-3.awsapprunner.com",
  c: "https://2ybemjudda.eu-west-3.awsapprunner.com",
  d: "https://awzip8yzdm.eu-west-3.awsapprunner.com",
  e: "https://k2b6qugmhv.eu-west-3.awsapprunner.com",
  f: "https://2ybemjudda.eu-west-3.awsapprunner.com",
  g: "https://k2b6qugmhv.eu-west-3.awsapprunner.com",
  h: "https://2ybemjudda.eu-west-3.awsapprunner.com",
  i: "https://2ybemjudda.eu-west-3.awsapprunner.com",
  j: "https://k2b6qugmhv.eu-west-3.awsapprunner.com",
  k: 'https://2ybemjudda.eu-west-3.awsapprunner.com',
  l: 'https://2ybemjudda.eu-west-3.awsapprunner.com',
  m: 'https://k2b6qugmhv.eu-west-3.awsapprunner.com',
  n: 'https://2ybemjudda.eu-west-3.awsapprunner.com',
  o: 'https://2ybemjudda.eu-west-3.awsapprunner.com',
  "": "https://2ybemjudda.eu-west-3.awsapprunner.com",
  static: "https://authentication.cactusmoments.com",
  local: "http://localhost:8080",
  fallback: "https://rjkt6hhbfm.eu-west-3.awsapprunner.com",
}

export const req = async (endpoint, method, body = undefined, server = 'x') => {
    const baseURL =
        // 'http://localhost:8080'
        servers[server]
    const accessToken = localStorage.getItem('accessToken')
    const res = await fetch(`${baseURL}${endpoint}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: accessToken,
        },
        body: JSON.stringify(body),
    })
    // const res = await fetch(`http://localhost:8080${endpoint}`, { method, headers: { 'Content-Type': "application/json", 'Accept': "application/json", "Authorization": accessToken}, body: JSON.stringify(body) })
    const { status, message, data } = replaceS3(await res.json())
    if (status !== 200) throw message
    return data
}
// export const req = async (
//     endpoint,
//     method,
//     body = undefined,
//     server = 'x',
//     options = {}
// ) => {
//     const { useCache = true, cacheTime = 5 * 60 * 1000 } = options // Default cache time: 5 minutes

//     // Create a cache key based on the request parameters
//     const cacheKey = JSON.stringify({ endpoint, method, body, server })

//     // For GET requests, check if we have a cached response
//     if (useCache && method.toUpperCase() === 'GET') {
//         const cachedData = apiCache.get(cacheKey)
//         if (cachedData) {
//             return cachedData
//         }
//     }

//     // If no cache hit or not using cache, proceed with the actual request
//     const baseURL = servers[server]
//     const accessToken = localStorage.getItem('accessToken')

//     const res = await fetch(`${baseURL}${endpoint}`, {
//         method,
//         headers: {
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//             Authorization: accessToken,
//         },
//         body: body ? JSON.stringify(body) : undefined,
//     })

//     const responseData = await res.json()
//     const { status, message, data } = replaceS3(responseData)

//     if (status !== 200) throw message

//     // Cache successful GET responses
//     if (useCache && method.toUpperCase() === 'GET' && status === 200) {
//         apiCache.set(cacheKey, data, cacheTime)
//     }

//     return data
// }

AWS.config.update({
  accessKeyId: 'AKIAS74TMAEA3LIJR43I',
  secretAccessKey: '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',
  region: 'eu-west-3',
});

const S3 = new AWS.S3()

export const uploadImageOnS3 = (f) => (src) => {
    // return new Promise((resolve, reject) => {
    try {
        const reader = new FileReader()
        console.log('spoooooooooooooooooorceeee', src)
        reader.onload = async (e) => {
            const params = JSON.parse(
                JSON.stringify({
                    Bucket: 'cactus-storage-s3',
                    Key: `${10000 + Math.round(Math.random() * 10000)}.png`,
                })
            )

            params.Body = new Buffer(
                reader.result.replace(/^data:image\/\w+;base64,/, ''),
                'base64'
            )

            console.log('peeraams', params, reader.result)

            let res = await S3.upload(params).promise().catch(console.error)
            console.log(res)
            // req('/user/resize', 'POST', { image: res.Location })
            return f(res.Location)
        }
        reader.onerror = (e) => console.log('OOPS!', e)
        reader.readAsDataURL(src.target.files[0])
    } catch (error) {
        console.error('Error uploading to S3:', error)
        // reject(error)
    }
    // })
}
